import { Link, Outlet } from "react-router-dom";
import { DataProvider } from "../../context/dataContext";

const Portalofio = () => {
    return (
        <div className="h-100 px-5 py-5">

            <div className="d-flex justify-content-between align-items-center">
                <div className="md-0">
                    <strong className="fs-4">Portafolio</strong> <br />
                    <small className="text-gray">A simple test of my skills</small>
                </div>
                <div className="md-0">
                    <Link to="new" className="btn btn-primary">
                        <i className="bi bi-plus"></i>
                        <span>Create new</span>
                    </Link>
                </div>
            </div>

            <DataProvider>
                <Outlet />
            </DataProvider>

        </div>
    )

}

export default Portalofio